/*
 *
 * Page: `@dbh/invoices-payment-form-page`.
 *
 */const importInvoicesPaymentFormPage=()=>import('./component-230f91da.js'/*  webpackChunkName: 'dbh.invoices-payment-form-page.component' */);const importInvoicesPaymentFormPageReducersAndSagas=()=>import('./reducers-and-sagas-27d941c3.js'/*  webpackChunkName: 'dbh.invoices-payment-form-page.reducers-and-sagas' */);

export { importInvoicesPaymentFormPage, importInvoicesPaymentFormPageReducersAndSagas };
